/**
 * Fixed-decimal formatting that can never throw. FMP fields are frequently
 * null/undefined (missing estimates, sparse international data), and a bare
 * `value.toFixed()` on one of those crashes the component tree. Route every
 * display-layer toFixed through this instead.
 */
export const safeToFixed = (
  value: number | null | undefined,
  decimals: number,
  fallback = "—",
): string =>
  typeof value === "number" && Number.isFinite(value)
    ? value.toFixed(decimals)
    : fallback;
